import { Message } from "primereact/message";
import { Messages } from "primereact/messages";
import { ProgressBar } from "primereact/progressbar";
import React, { useRef } from "react";

export interface ResultWithProgressProps {
  isObserving: boolean,
  progress: number | null,
  lastLog: string,
  logs: string[],
  isError: boolean,
  error: Error | null,
  children?: React.ReactNode
}

const ResultWithProgress : React.FC<ResultWithProgressProps> =
  ({ isObserving, progress, lastLog,logs, isError, error, children }) => {
    const messages = useRef<Messages>(null);
    if(isError){
      // APIが返す detail（原因箇所つきのメッセージ）を優先して表示する
      const detail = ((): string => {
        const body = (error as { body?: { detail?: unknown } } | null)?.body
        if (typeof body?.detail === 'string') {
          return body.detail
        }
        return error?.message ?? ''
      })()
      // detail と進捗ログが同じ内容を含む場合は重複表示しない
      const messagesToShow = [detail, lastLog]
        .filter(Boolean)
        .filter((message, _, list) => !list.some(other => other !== message && other.includes(message)))
      return (
        <div className="p-message p-component p-message-error p-message-enter-done">
          <div className="p-message-wrapper flex flex-column align-items-start gap-2">
            <div className="flex flex-row align-items-center gap-2">
              <i className="pi pi-times-circle" style={{position: "relative",top: "2px"}}></i>
              <span className="p-message-summary">エラー</span>
            </div>
            {messagesToShow.map((message, index) => (
              <span key={index} className="p-message-detail" style={{whiteSpace: "pre-wrap"}}>{message}</span>
            ))}
          </div>
        </div>
      )
    }
    if(isObserving || children === undefined){
      return (
        <div className="p-3 surface-ground border-round w-full">
          {progress !== null && (progress! > 0.1) ? (
            <ProgressBar value={Math.round(progress * 100)} showValue={true} />
          ) : (
            <ProgressBar value={0} />
          )}
          <p className="mx-auto text-center">{lastLog}</p>
        </div>
      )
    }
    return (
      <>
        {children}
      </>
    )
  };

export default ResultWithProgress;
